export default function prettytime(milliseconds) {
	if (milliseconds === 0) {
		return '00:00:00'
	}

	// var daysDifference = Math.floor(difference / 1000 / 60 / 60 / 24);
	// difference -= daysDifference * 1000 * 60 * 60 * 24

	// var hoursDifference = Math.floor(difference / 1000 / 60 / 60);
	// difference -= hoursDifference * 1000 * 60 * 60

	// var minutesDifference = Math.floor(difference / 1000 / 60);
	// difference -= minutesDifference * 1000 * 60

	// var secondsDifference = Math.floor(difference / 1000);

	// return daysDifference + ':' + hoursDifference + ':' + minutesDifference + ':' + secondsDifference;
	// calculate days
	const days = Math.floor(milliseconds / 86400);
	milliseconds -= days * 86400;

	// calculate hours
	const hours = Math.floor(milliseconds / 3600) % 24;
	milliseconds -= hours * 3600;

	// calculate minutes
	const minutes = Math.floor(milliseconds / 60) % 60;
	milliseconds -= minutes * 60;

	// calculate seconds
	const seconds = Math.floor(milliseconds)

	let difference = '';

	difference += (days < 10) ? `0${days}d` : `${days}d`;

	difference += (hours < 10) ? `:0${hours}h` : `:${hours}h`;

	difference += (minutes < 10) ? `:0${minutes}m` : `:${minutes}m`;

	difference += (seconds < 10) ? `:0${seconds}s` : `:${seconds}s`;

	return difference;
}
